import React from "react";
import { IconButton, TruncateTooltip, Typography } from "..";

import CloseIcon from "@tiny/icons/generated/CloseBig";
import useBreakpoints from "../hooks/useBreakpoints";
import { useStyles } from "./DialogTitle.styles";
import { DialogTitleProps } from "./DialogTitle.types";
import DialogContext from "../Dialog/DialogContext";

function DialogTitle(props: DialogTitleProps) {
  const { subtitle, image, children, noWrap = true } = props;

  const classes = useStyles();

  const { mdUp } = useBreakpoints();

  const { onClose, closeDisabled } = React.useContext(DialogContext);

  return (
    <div className={classes.root}>
      <div className={classes.wrap}>
        <div className={classes.image}>{image}</div>
        {noWrap ? (
          <TruncateTooltip>
            <Typography
              className={classes.title}
              variant={mdUp ? "h3" : "h4"}
              component="h2"
              fontWeight="semiBold"
              color="grey"
              tone={900}
              noWrap
            >
              {children}
            </Typography>
          </TruncateTooltip>
        ) : (
          <Typography
            className={classes.title}
            variant="h3"
            component="h2"
            fontWeight="semiBold"
            color="grey"
            tone={900}
          >
            {children}
          </Typography>
        )}
      </div>
      <div className={classes.close}>
        <IconButton
          className={classes.closeIcon}
          onClick={onClose}
          disableRipple
          disabled={closeDisabled}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </div>
      {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
    </div>
  );
}

export default DialogTitle;
